"use strict";
'use es6'; // This should stay in sync with the enum in EE. We should verify that with integration tests.
// https://git.hubteam.com/HubSpotProtected/EligibilityEngine/blob/master/EligibilityEngineCore/src/main/java/com/hubspot/eligibilityengine/core/enums/PurchaseMotion.java

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_ACCOUNT = exports.ASSIGN_SEAT = exports.REQUEST_SEAT = exports.PRICING_PAGE_REDIRECT = exports.ACTIVATE = exports.BUY_ADDITIONAL_SEATS = exports.BUY_ADDITIONAL_CONTACTS = exports.TALK_TO_SALES_FALLBACK = exports.TRIAL = exports.TALK_TO_SALES = exports.BUY_TOUCHLESS = void 0;
var BUY_TOUCHLESS = 'buyTouchless';
exports.BUY_TOUCHLESS = BUY_TOUCHLESS;
var TALK_TO_SALES = 'talkToSales';
exports.TALK_TO_SALES = TALK_TO_SALES;
var TRIAL = 'trial';
exports.TRIAL = TRIAL;
var TALK_TO_SALES_FALLBACK = 'talkToSalesFallback';
exports.TALK_TO_SALES_FALLBACK = TALK_TO_SALES_FALLBACK;
var BUY_ADDITIONAL_CONTACTS = 'buyAdditionalContacts';
exports.BUY_ADDITIONAL_CONTACTS = BUY_ADDITIONAL_CONTACTS;
var BUY_ADDITIONAL_SEATS = 'buyAdditionalSeats';
exports.BUY_ADDITIONAL_SEATS = BUY_ADDITIONAL_SEATS;
var ACTIVATE = 'activate';
exports.ACTIVATE = ACTIVATE;
var PRICING_PAGE_REDIRECT = 'pricingPageRedirect';
exports.PRICING_PAGE_REDIRECT = PRICING_PAGE_REDIRECT;
var REQUEST_SEAT = 'requestSeat';
exports.REQUEST_SEAT = REQUEST_SEAT;
var ASSIGN_SEAT = 'assignSeat';
exports.ASSIGN_SEAT = ASSIGN_SEAT;
var VIEW_ACCOUNT = 'viewAccount';
exports.VIEW_ACCOUNT = VIEW_ACCOUNT;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/purchaseMotions/PurchaseMotionTypes.js
// module id = 68
// module chunks = 5 6 7